import produce from 'immer';
import { AnyAction } from 'redux';
import { AUTH_ACTIONS } from '../actions/actions';
import { authState } from '../../types/state';

const initialState: authState = {
  isAuthenticated: false,
  userData: undefined,
  error: undefined,
  isLoading: true,
  timezone: 'UTC',
};

const authReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case AUTH_ACTIONS.LOADING: {
      return produce(state, (df) => {
        df.isLoading = action.payload;
      });
    }
    case AUTH_ACTIONS.LOGIN_SUCCESS: {
      return produce(state, (df) => {
        df.isAuthenticated = true;
        df.userData = action.payload;
      });
    }
    case AUTH_ACTIONS.LOGIN_FAILURE: {
      return produce(state, (df) => {
        df.isAuthenticated = false;
        df.error = action.payload;
      });
    }
    case AUTH_ACTIONS.LOGOUT: {
      return { ...initialState, isLoading: false };
    }

    case AUTH_ACTIONS.UPDATE_TIMEZONE: {
      return produce(state, (df) => {
        df.timezone = action.payload;
      });
    }
    default:
      return state;
  }
};
export default authReducer;
